import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";

function HotelFilter() {
  const [guestRooms, setGuestRooms] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCities] = useState([]);
  const [departure, setDeparture] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    // Extract values from URL
    const fromParam = searchParams.get("from");
    const roomsParam = searchParams.get("rooms");
    const departureParam = searchParams.get("departure");
    const returnParam = searchParams.get("return");

    if (departureParam) setDeparture(departureParam);
    if (returnParam) setReturnDate(returnParam);

    // Parse and format rooms data
    if (roomsParam) {
      try {
        const roomsArray = JSON.parse(decodeURIComponent(roomsParam));
        const formattedRooms = roomsArray
          .map((room) => `${room.adults} Adults${room.children > 0 ? `, ${room.children} Children` : ""}`)
          .join(" · ");
        setGuestRooms(formattedRooms);
      } catch (error) {
        console.error("Error parsing rooms parameter:", error);
      }
    }

    // Fetch city data if 'from' is available
    if (fromParam) {
      fetchCityByCode(fromParam);
    }

    // Initialize jQuery Datepicker
    $("#departure").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: 0,
      onSelect: (dateText) => setDeparture(dateText),
    });

    $("#return").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: 1,
      onSelect: (dateText) => setReturnDate(dateText),
    });
  }, []);

  const fetchCityByCode = async (cityCode) => {
    try {
      const response = await axios.get(`${baseurl}getCityByCode?code=${cityCode}`);
      if (response.data.city) {
        setSelectedCity({
          value: response.data.city.city_code,
          label: `${response.data.city.city_name} (${response.data.city.country_name})`,
        });
      }
    } catch (error) {
      console.error("Error fetching city by code:", error);
    }
  };

  const handleSearch = () => {
    const baseUrl1 = window.location.origin; // Get the current base URL dynamically
    console.log("baseUrl1", baseUrl1);
  
    // Calculate days between departure and returnDate
    let dayCount = 0;
    if (departure && returnDate) {
      const departureDate = new Date(departure);
      const returnDateObj = new Date(returnDate);
      dayCount = Math.max(
        Math.ceil((returnDateObj - departureDate) / (1000 * 60 * 60 * 24)), // Convert ms to days
        0
      );
    }
  
    const url = `${baseUrl1}/hotel-result?from=${selectedCity?.value || ""}&departure=${departure}&return=${returnDate}&day=${dayCount}&rooms=${encodeURIComponent(
      JSON.stringify([{ adults: 2, children: 0 }])
    )}`;
  
    window.location.href = url;
  };
  

  return (
    <div className="bg-filter py-3 px-4 rounded sticky-top">
      <div className="container">
        <div className="row g-3 align-items-center">
          {/* Location Input */}
          <div className="col-md-3">
            <label className="text-white small fw-bold">AREA, LANDMARK OR PROPERTY NAME</label>
            <Select
              options={cities.map((city) => ({
                value: city.city_code,
                label: `${city.city_name} (${city.country_name})`,
              }))}
              name="from"
              className="text-dark"
              placeholder="Search City"
              value={selectedCity}
              isDisabled
            />
          </div>

          {/* Check-in Date */}
          <div className="col-md-2">
            <label className="text-white small fw-bold">CHECKIN</label>
            <input type="text" id="departure" name="departure" className="form-control" value={departure} readOnly />
          </div>

          {/* Checkout Date */}
          <div className="col-md-2">
            <label className="text-white small fw-bold">CHECKOUT</label>
            <input type="text" id="return" name="return" className="form-control" value={returnDate} readOnly />
          </div>

          {/* Guest & Rooms */}
          <div className="col-md-3">
            <label className="text-white small fw-bold">GUEST & ROOMS</label>
            <input type="text" name="guest_rooms" className="form-control" value={guestRooms || "N/A"} readOnly />
          </div>

          {/* Update Search Button */}
          <div className="col-md-2">
            <button className="btn btn-primary w-100" onClick={handleSearch}>Update Search</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HotelFilter;
